import { Box, Grid, GridItem, Text, Tooltip } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  AcceptedIcon,
  AddButton,
  AssignedIcon,
  IncomingIcon,
  PendingIcon,
  RejectedIcon,
} from "../../assets/svgs/Icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import OutgoingTC from "./OutgoingTC";
import IncomingTC from "./IncomingTC";
import ReturnedTC from "./ReturnedTC";
import { countsForTCClient } from "./TransactionCertificateSlice";
import isAllowed from "../../routing/isAllowed";
import ApprovedShipments from "./ApprovedShipments";

const TransactionCertificate = () => {
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState("idle");
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(0);

  const { counts } = useSelector((state) => state.transactionCertificateClient);

  let countForClient = counts?.["CLIENT"];

  // const getCounts = () => {
  //   try {
  //     setStatus("pending");
  //     dispatch(countsForTCClient());
  //     setStatus("success");
  //   } catch (error) {
  //     setStatus("failed");
  //     ;
  //   }
  // };

  const getCounts = async () => {
    try {
      setStatus("pending");
      await dispatch(countsForTCClient());
      setStatus("success");
    } catch (error) {
      setStatus("failed");
    }
  };

  const navigate = useNavigate();

  const STEP_PAGES = [
    {
      id: 0,
      component: () => <OutgoingTC />,
    },
    {
      id: 1,
      component: () => <IncomingTC />,
    },
    {
      id: 2,
      component: () => <ReturnedTC />,
    },
    {
      id: 3,
      component: () => <ApprovedShipments />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setPage(tabIndex);
    // Updates localStorage with new active tab index
    localStorage.setItem("activeTab", tabIndex);
  };

  // useEffect(() => {
  //   const storedActiveTab = localStorage.getItem("activeTab");
  //   if (storedActiveTab) {
  //     setPage(parseInt(storedActiveTab));
  //     setIsActive(parseInt(storedActiveTab));
  //   }
  // }, [page, isActive]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get("tab");

  useEffect(() => {
    if (tabParam === "incoming") {
      setPage(1); // Set the page to the index of the "Incoming" component
      localStorage.setItem("activeTab", 1);
    } else if (tabParam === "pending") {
      setPage(2); // Set the page to the index of the "Pending" component
      localStorage.setItem("activeTab", 2);
    } else {
      // Default behavior or other tabs
      // setPage(0);
      // localStorage.setItem("activeTab", 0);
    }
  }, [tabParam]);

  useEffect(() => {
    let storedActiveTab = localStorage.getItem("activeTab") || 0;
    if (storedActiveTab > STEP_PAGES.length - 1) {
      storedActiveTab = 0;
    }
    setPage(parseInt(storedActiveTab));
    setIsActive(parseInt(storedActiveTab));

    const fetchCounts = async () => {
      await getCounts();
    };

    fetchCounts();
  }, [page, isActive]);

  // useEffect(() => {
  //   getCounts();
  // }, []);

  return (
    <Box>
      <Box bg="#EDF3F8" marginTop="2rem">
        <Grid
          width={"80%"}
          templateColumns="repeat(5, 1fr)"
          my={"1rem"}
          gap="0.8rem"
          height={"100%"}
        >
          <GridItem>
            {/* <Tooltip label={"By clicking on the button, you will be directed to the transaction certificate form where you can add your transaction certificate."}> */}
            <Box
              bg={"#FFF"}
              color="#141D43"
              width={"250px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              // boxShadow={
              //   isActive === 2
              //     ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
              //     : ""
              // }
              onClick={() => {
                navigate("/client/transaction-certificates/tc-form");
              }}
            >
              <Grid templateColumns="repeat(1,1fr)">
                <GridItem mt={"3rem"}>
                  <AddButton width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {/* {counts?.["PENDING"] || 0} */}
                  </Text>
                  <Text fontSize={"16px"} fontWeight="700" textAlign={"center"}>
                    Transaction Certificate
                  </Text>
                </GridItem>
              </Grid>
            </Box>
            {/* </Tooltip> */}
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 0 ? "#fff" : "#B1DFFF"}
              color="#141D43
                            "
              width={"250px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              d={"flex"}
              boxShadow={
                isActive === 0
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(0);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <IncomingIcon width="20" height="20" />
                </GridItem>

                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForClient?.["OUTGOING"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Outgoing TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>

          <GridItem>
            <Box
              bg={isActive === 1 ? "#fff" : "#B8C9EA"}
              color="#141D43
                            "
              width={"250px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              boxShadow={
                isActive === 1
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              textAlign={"center"}
              onClick={() => {
                handleTabClick(1);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AssignedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForClient?.["INCOMING"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Incoming TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 2 ? "#fff" : "#FFD5D3"}
              color="#141D43"
              width={"250px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 2
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(2);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <PendingIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForClient?.["PENDING"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Pending TC
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          {/* Commenting it because 1.5 will be implemented later */}
          {/* <GridItem>
            <Box
              bg={isActive === 3 ? "#fff" : "#52BBFF"}
              color="#141D43"
              width={"250px"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 3
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(3);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AcceptedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text fontWeight={"bold"} fontSize={"44px"}>
                    {countForClient?.["PENDING"] || 0}
                  </Text>
                  <Text fontSize={"24px"} fontWeight="500" textAlign={"left"}>
                    Approved Shipments
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem> */}
        </Grid>
      </Box>
      {STEP_PAGES[page]?.component()}
      {/* child */}
    </Box>
  );
};

export default isAllowed(TransactionCertificate);
